import { DataTypeProvider } from '@devexpress/dx-react-grid';
import OnDiskFalseIcon from '../../../NRIcons/OnDiskFalseIcon';
import OnDiskTrueIcon from '../../../NRIcons/OnDiskTrueIcon';
import { useTheme } from '@mui/material/styles';

const OnDiskFormatter = ({ value }) => {
  const theme = useTheme();
  return (
    <>
      {value ? (
        <OnDiskTrueIcon color={theme.palette.info.main} width={20} height={20} />
      ) : (
        <OnDiskFalseIcon color={theme.palette.text.disabled} width={20} height={20} />
      )}
    </>
  );
};
export const NROnDiskProvider = props => <DataTypeProvider formatterComponent={OnDiskFormatter} {...props} />;
